import React from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import Header from "./Header";

/**
 * Full-page "this feature is locked" screen. Shown when a member tries
 * to reach a route their admin hasn't granted them access to
 * (Employz Intelligence sub-pages, AI Office handoff, etc.).
 */
export default function LockedFeature({
  featureName = "This feature",
  description = "Your admin hasn't granted you access yet.",
  testid = "locked-feature",
}) {
  const nav = useNavigate();
  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-4xl mx-auto px-6 md:px-10 py-20">
        <div
          data-testid={testid}
          className="rounded-2xl border border-amber-500/25 bg-zinc-950/40 grain relative overflow-hidden p-10 text-center"
        >
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent" />
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-amber-500/40 bg-amber-500/10 text-amber-300">
            <Lock className="w-6 h-6" />
          </div>
          <div className="mt-5 text-[10px] uppercase tracking-[0.3em] text-amber-300/80">
            // access locked
          </div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter font-black mt-2">
            {featureName} is locked
          </h1>
          <p className="text-zinc-400 text-sm mt-4 max-w-lg mx-auto">
            {description} Ask them to unlock it from{" "}
            <span className="text-amber-300">Admin Console → Users</span> and
            you&apos;ll get access instantly.
          </p>
          <button
            data-testid={`${testid}-back-btn`}
            onClick={() => nav("/dashboard")}
            className="mt-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] px-4 py-2.5 rounded-md border border-zinc-800 text-zinc-300 hover:text-white hover:border-zinc-600 transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" />
            Back to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
